function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import { State } from './state';
import PairingFlowStateMachine from './state-machine';
/* eslint-disable no-use-before-define */
// Unlike the Supplicant, the Authority web code does not speak directly to the channel server,
// all communication is done via the WebChannels in the browser.

let WaitForAuthorizations = /*#__PURE__*/function (_State) {
  _inherits(WaitForAuthorizations, _State);

  var _super = _createSuper(WaitForAuthorizations);

  function WaitForAuthorizations() {
    var _this;

    _classCallCheck(this, WaitForAuthorizations);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "name", 'WaitForAuthorizations');

    _this.navigate('pair/auth/allow'); // We listen for both messages at the same time because the pairing process
    // needs to be authorized on both ends to succeed.


    _this.listenTo(_this.notifier, 'pair:supp:authorize', () => {
      _this.gotoState(WaitForAuthorityAuthorize);
    });

    _this.listenTo(_this.notifier, 'pair:auth:authorize', result => {
      _this.gotoState(WaitForSupplicantAuthorize, result);
    });

    return _this;
  }

  return _createClass(WaitForAuthorizations);
}(State);

let WaitForSupplicantAuthorize = /*#__PURE__*/function (_State2) {
  _inherits(WaitForSupplicantAuthorize, _State2);

  var _super2 = _createSuper(WaitForSupplicantAuthorize);

  function WaitForSupplicantAuthorize() {
    var _this2;

    _classCallCheck(this, WaitForSupplicantAuthorize);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "name", 'WaitForSupplicantAuthorize');

    _this2.navigate('/pair/auth/wait_for_supp');

    _this2.listenTo(_this2.notifier, 'pair:supp:authorize', () => {
      _this2.gotoState(PairAuthComplete, {});
    });

    return _this2;
  }

  return _createClass(WaitForSupplicantAuthorize);
}(State);

let WaitForAuthorityAuthorize = /*#__PURE__*/function (_State3) {
  _inherits(WaitForAuthorityAuthorize, _State3);

  var _super3 = _createSuper(WaitForAuthorityAuthorize);

  function WaitForAuthorityAuthorize() {
    var _this3;

    _classCallCheck(this, WaitForAuthorityAuthorize);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "name", 'WaitForAuthApprove');

    _this3.listenTo(_this3.notifier, 'pair:auth:authorize', () => {
      _this3.gotoState(PairAuthComplete);
    });

    return _this3;
  }

  return _createClass(WaitForAuthorityAuthorize);
}(State);

let PairAuthComplete = /*#__PURE__*/function (_State4) {
  _inherits(PairAuthComplete, _State4);

  var _super4 = _createSuper(PairAuthComplete);

  function PairAuthComplete() {
    var _this4;

    _classCallCheck(this, PairAuthComplete);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _this4.navigate('pair/auth/complete');

    return _this4;
  }

  return _createClass(PairAuthComplete);
}(State);

let PairAuthFailure = /*#__PURE__*/function (_State5) {
  _inherits(PairAuthFailure, _State5);

  var _super5 = _createSuper(PairAuthFailure);

  function PairAuthFailure() {
    var _this5;

    _classCallCheck(this, PairAuthFailure);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));

    _this5.navigate('pair/failure');

    return _this5;
  }

  return _createClass(PairAuthFailure);
}(State);

let AuthorityStateMachine = /*#__PURE__*/function (_PairingFlowStateMach) {
  _inherits(AuthorityStateMachine, _PairingFlowStateMach);

  var _super6 = _createSuper(AuthorityStateMachine);

  function AuthorityStateMachine(attrs) {
    var _this6;

    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AuthorityStateMachine);

    _this6 = _super6.call(this, attrs, options);

    _this6.createState(WaitForAuthorizations);

    return _this6;
  }

  _createClass(AuthorityStateMachine, [{
    key: "heartbeatError",
    value: function heartbeatError(error) {
      this.createState(PairAuthFailure, {
        error
      });
    }
  }]);

  return AuthorityStateMachine;
}(PairingFlowStateMachine);

export default AuthorityStateMachine;
export { WaitForAuthorizations, WaitForSupplicantAuthorize, WaitForAuthorityAuthorize, PairAuthComplete, PairAuthFailure, AuthorityStateMachine };
/* eslint-enable no-use-before-define */